import type React from 'react';

import type { PetitionDetails } from 'src/app/pages/petitionDetails/shared/types';

import { OrganizationLink } from './components/OrganizationLink';
import { UserLink } from './components/UserLink';

type Props = Readonly<{
	user: PetitionDetails['user'];
	organization: PetitionDetails['organization'];
}>;

export const StarterLink: React.FC<Props> = ({ user, organization }) => {
	return organization ? <OrganizationLink organization={organization} /> : <UserLink user={user} />;
};
